<mat-accordion [multi]="true" *ngIf="order">
  <div class="container-group">
    <mat-expansion-panel hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title class="summary-title">
          {{ 'myAccount.orderDetails.paymentReturnSummary.payment.title' | cxTranslate }}
        </mat-panel-title>
        <mat-icon class="material-icons-sharp light material-icons mat-icon-no-color" role="img">expand_more</mat-icon>
      </mat-expansion-panel-header>
      <div class="summary-details">
        <div class="payment-group-info" [class.w-100]="order?.paymentInfoDetails?.cardType">
          <span class="payment-title">{{ 'checkout.group.payment.paymentModeTitle' | cxTranslate }}</span>
          <div class="d-flex" *ngIf="order?.paymentInfoDetails?.cardType; else defaultPaymentModeTemplate">
            <span class="payment-value">{{
              'myAccount.orderDetails.paymentReturnSummary.payment.cardDetails'
                | cxTranslate
                  : { cardType: order.paymentInfoDetails.cardType, cardNumber: order.paymentInfoDetails.cardNumber }
            }}</span>
            <span class="payment-value ml-2">
              {{
                'myAccount.orderDetails.paymentReturnSummary.payment.cardExpiration'
                  | cxTranslate : { cardExpiration: order.paymentInfoDetails.expiration }
              }}</span
            >
          </div>
          <span class="payment-value">
            {{
              'myAccount.orderDetails.paymentReturnSummary.payment.cardName'
                | cxTranslate : { accountHolderName: order.paymentInfoDetails.accountHolderName }
            }}
          </span>
          <ng-template #defaultPaymentModeTemplate>
            <span class="payment-value">{{ order?.paymentInfoDetails?.paymentModeName }}</span>
          </ng-template>
        </div>
        <div class="payment-group-info">
          <span class="payment-title">{{ 'checkout.group.payment.paymentModeTerms' | cxTranslate }}</span>
          <span class="payment-value">{{
            'checkout.group.payment.paymentModeTermsInDays'
              | cxTranslate : { termsUnit: order?.paymentInfoDetails?.paymentTerms }
          }}</span>
        </div>
      </div>
    </mat-expansion-panel>
    <mat-expansion-panel hideToggle>
      <mat-expansion-panel-header>
        <mat-panel-title class="summary-title">
          {{ 'myAccount.orderDetails.paymentReturnSummary.return.title' | cxTranslate }}
        </mat-panel-title>
        <mat-icon class="material-icons-sharp light material-icons mat-icon-no-color" role="img">expand_more</mat-icon>
      </mat-expansion-panel-header>
      <div class="summary-details">
        <div class="group-info">
          {{ 'myAccount.orderDetails.paymentReturnSummary.return.desc' | cxTranslate }}
        </div>
      </div>
    </mat-expansion-panel>
  </div>
</mat-accordion>
